/**
 * Silent session refresh — NO LONGER NEEDED.
 *
 * BetterAuth handles session renewal transparently on the IdP side. When the
 * local session cookie expires, the frontend redirects to /auth/login which
 * triggers a new OIDC authorize. BetterAuth's long-lived server session issues
 * a new code immediately (no login page shown — silent re-auth).
 *
 * This module is kept as a no-op stub so any residual imports don't break.
 */

export async function refresh(): Promise<boolean> {
  // No-op: BetterAuth handles session renewal transparently.
  // A 401 triggers a full redirect to /auth/login for silent re-auth.
  return false;
}
